var TaxStrategyTypes = /* @__PURE__ */ ((TaxStrategyTypes2) => {
  TaxStrategyTypes2[TaxStrategyTypes2["incomeAndIndirect"] = 1] = "incomeAndIndirect";
  TaxStrategyTypes2[TaxStrategyTypes2["income"] = 2] = "income";
  TaxStrategyTypes2[TaxStrategyTypes2["deposit"] = 3] = "deposit";
  return TaxStrategyTypes2;
})(TaxStrategyTypes || {});
export {
  TaxStrategyTypes
};
